import { BooleanParam, StringParam, withDefault } from 'use-query-params';

export const queryParams = {
  desc: withDefault(BooleanParam, true),
  before: StringParam,
  after: StringParam,
};
